import React from "react";

function TaskActionButton({ onClick, className, title, iconSrc, children }) {
  return (
    <button
      className={`task-action-button ${className || ""}`}
      onClick={(e) => {
        e.stopPropagation(); // Prevent event from bubbling to parent elements like the task itself
        if (onClick) {
          onClick(e);
        }
      }}
      title={title}
      aria-label={title}
    >
      {iconSrc && <img src={iconSrc} alt={title || "action"} />}
      {children && <span>{children}</span>}
    </button>
  );
}

export default TaskActionButton;
